import { mapGetters, mapActions, mapMutations } from 'vuex'
import Loading from '@/components/loading/index.vue'

export default {
  components: {
    Loading
  },
  props: {
    value: {
      required: true,
      type: Boolean
    }
  },
  data () {
    return {
      dialog: false,
      isLoading: false,
      // Guarantees that the user have read the consequences and agreed with them before blocking a provider
      userAgreedWithConsequences: false,
      desc: '',
      accept: '',
      descRules: [
        (v) => !!v || 'Motivo é requerido.',
        (v) => (v && v.length > 3) || 'A descrição deve ser no mínimo 3 caracters'
      ]
    }
  },
  computed: {
    ...mapGetters([
      'getterAccount',
      'getterSelectedSystemProvider'
    ]),
    isValid () {
      let result = false

      if (this.desc.length > 3) {
        result = true
      } else {
        result = false
      }

      return result
    },
    isConfirmMessage () {
      if (this.accept.toLowerCase().trim() === 'eu concordo') {
        return true
      }
      return false
    },
    allowProviderBlockModal () {
      if (!this.getterSelectedSystemProvider.enabled || this.userAgreedWithConsequences) {
        return true
      }
      return false
    },
    isProviderEnabled () {
      return !this.getterSelectedSystemProvider.enabled
    }
  },
  mounted () {
    this.dialog = true
  },
  beforeDestroy () {
    this.SET_SELECTED_SYSTEM_PROVIDER()
  },
  methods: {
    ...mapActions([
      'actionEnableSystemProvider',
      'actionGetAllSystemProviders'
    ]),
    ...mapMutations([
      'SET_SELECTED_SYSTEM_PROVIDER'
    ]),
    closeModal () {
      this.dialog = false

      setTimeout(() => {
        this.$emit('input', false)
      }, 300)
    },
    userAgreed () {
      this.userAgreedWithConsequences = true
    },
    enableProvider () {
      const params = {
        provider: this.getterSelectedSystemProvider,
        idSystemProvider: this.getterSelectedSystemProvider.idSystemProvider,
        desc: this.desc,
        idUserLogged: this.getterAccount.idUser
      }

      this.isLoading = true

      this.actionEnableSystemProvider(params)
        .then(() => {
          this.closeModal()

          this.actionGetAllSystemProviders()

          this.sendToast({
            text: `Provider ${(!this.getterSelectedSystemProvider.enabled ? 'bloqueado' : 'desbloqueado')} com sucesso`,
            type: 'success'
          })
        })
        .catch(() => {
          this.sendToast({
            text: 'Ocorreu um erro ao atualizar o provider, tente novamente mais tarde!',
            type: 'danger'
          })

          this.isLoading = false
        })
    }
  }
}
